export default __webpack_public_path__ + "static/media/directions_car-white-18dp.6340810e.svg";